import { useParams } from "react-router-dom";
import { Subscription } from "../features/subscription";

export function SubscriptionPage() {
  const prms = useParams();
  const subscriptionId = prms.subscriptionId ?? "";
  return <Subscription subscriptionId={subscriptionId} />;
}
